export const equipmentServiceItems = [
  {
    label: 'ネットワーク対応精算機',
    to: '/service/internet/',
    icon: 'icon-netdeal',
  },
  {
    label: 'NNポールシステム',
    to: '/service/lockless/',
    icon: 'icon-lockless',
  },
  {
    label: 'NNカメラシステム',
    to: '/service/nncamera/',
    icon: 'icon-nncamera',
  },
  {
    label: 'ゲート式駐車場管理システム',
    to: '/service/gate/',
    icon: 'icon-gatesystem',
  },
  {
    label: 'ロック板ユニット',
    to: '/service/unit/',
    icon: 'icon-lockunit',
  },
  {
    label: 'バイク用ロック板ユニット',
    to: '/service/bike/',
    icon: 'icon-bikelock',
  },
  {
    label: '駐輪管理システム',
    to: '/service/bicycle/',
    icon: 'icon-bicycle',
  },
  {
    label: '防犯カメラ',
    to: '/service/camera/',
    icon: 'icon-surveillancecamera',
  },
  {
    label: '生産終了及び保守のご案内',
    href: '/assets/files/itc-product-maintenance.pdf',
    icon: 'icon-setting',
    external: true,
  },
]

export const softwareServiceItems = [
  {
    label: '遠隔管理システム',
    to: '/service/remote/',
    icon: 'icon-remotecontrol',
  },
  {
    label: 'SmartPay',
    to: '/service/smartpay/',
    icon: 'icon-smartpay',
  },
  {
    label: 'QT-netサービス',
    to: '/service/qtnetservice/',
    icon: 'icon-qtnet',
    listClass: 'qt',
  },
  {
    label: 'QT-net',
    to: '/service/qtnet/',
    icon: 'icon-qtnet',
    listClass: 'qt',
  },
]

export const operationServiceItems = [
  {
    label: '管理サポート',
    to: '/service/support/',
    icon: 'icon-support',
  },
]

export const serviceCategories = [
  {
    id: 'equipment',
    label: '駐車場機器',
    topLink: { to: '/service/equipment/', label: '駐車場機器' },
    items: equipmentServiceItems,
  },
  {
    id: 'software',
    label: 'ソフトウェア',
    topLink: { to: '/service/software/', label: 'ソフトウェア' },
    items: softwareServiceItems,
  },
  {
    id: 'operation',
    label: 'オペレーション',
    topLink: { to: '/service/operation/', label: 'オペレーション' },
    items: operationServiceItems,
  },
]
